import TemplateView from "../../TemplateView";
import {onKeyDown, isEsc} from "../../keyHandlers/index";
import {onOutsideClick} from "../../atBrowserUtils";
import ScrollUtils from "../../util/ScrollUtils";
import {shouldEventPreventHiding} from '../../panels/utils'

export default class DialogWithPointerWrapper extends TemplateView {
    constructor($containerElement, $pageEl, {dialog, className, dialogType}) {
        super($containerElement);

        this.$pageEl = $pageEl;
        this.params = {
            dialog,
            className,
            dialogType,
        }
    }

    templateHtml() {
        return "<div class='dialogWithPointerWrapper <%=className%>'>" +
               "    <div class='content'></div>" +
               "    <div class='pointer'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            ...this.params
        }
    }

    init(ignore){
        if (this.$content){
            this.$content.empty();
        }
        super.init()
        return this;
    }

    afterRender(){
        this.$content = this.find('.content');
        this.params.dialog.init(this.$content);
        this.$pointer = this.find('.pointer');

        this.$el.hide();
    }

    show($el) {
        super.show();
        this.params.dialog.show()
        this._setPointerPosition($el);

        onOutsideClick(this.$el,
            this.params.dialogType,
            () => { this.hide() },
            (e) => { return shouldEventPreventHiding(e, this.params.dialogType) },
            this.$pageEl);

        this.setupKeyDownHandler();

        ScrollUtils.addVerticalScroll(this.$content);
    }

    restoreOnKeyDownHandler() {
        if (this.removeHandler) this.removeHandler()
    }

    setupKeyDownHandler() {
        this.removeHandler = onKeyDown((code) => {
            if (isEsc(code)) {
                this.hide();
                return true;
            }
        });
    }

    update(){
        super.update();
        this.params.dialog.update()
    }

    hide(){
        super.hide();
        this.restoreOnKeyDownHandler()
        this.params.dialog.hide()
    }

    setState(state){
        this.params.dialog.setState(state)
    }

    setDialog(dialog){
        this.params.dialog = dialog;
    }

    _setPointerPosition($el){
        const pointerOffset = $el.offset().left + $el.width()/2 - this.$el.offset().left;
        const contentOffset = $el.offset().left + $el.width()/2 - this.$el.offset().left - this.$el.width()/2;

        this.$pointer.css('left', pointerOffset);
        this.$content.css('left', contentOffset);
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/DialogWithPointerWrapper.js